module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "main-toolbar"
  }, [(_vm.project) ? _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), (_vm.currentVersion) ? _c('span', {
    staticClass: "project-version"
  }, [_vm._v(_vm._s(_vm.currentVersion.name))]) : _c('span', {
    staticClass: "project-version-live"
  }, [_vm._v("Live Edit")]), _vm._v(" "), (_vm.locked) ? _c('md-icon', [_vm._v("lock")]) : _vm._e(), _vm._v(" "), (_vm.locked) ? _c('md-tooltip', [_vm._v("This version is locked")]) : _vm._e()], 1), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": require('../../assets/img/cuelist.png'),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('project-search')], 1) : _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": require('../../assets/img/cuelistWHITE.png'),
      "alt": "cuelisttext"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc358206","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/core/header.vue
// module id = 678
// module chunks = 2